import React from "react";
import logo from "../images/logoForLightTheme.png";
import "./hm-theme.css";

function Termsandcondition() {
  return (
    <div className="hm-page-wrapper container-fluid px-3 py-4">
      <div className="hm-card max-width-1100 mx-auto">
        {/* Header Banner */}
        <div className="hm-card-header d-flex align-items-center justify-content-between flex-wrap gap-3 py-3 px-4" style={{ background: "linear-gradient(135deg, #2f3a88 0%, #2cb6e9 100%)", borderRadius: "18px 18px 0 0" }}>
          <div className="d-flex align-items-center gap-3">
            <div className="bg-white p-2 rounded-3 d-flex align-items-center justify-content-center" style={{ height: "48px" }}>
              <img
                src={logo}
                alt="HealrMed Logo"
                style={{ height: "36px", objectFit: "contain" }}
              />
            </div>
            <div>
              <h3 className="text-white fw-bold mb-0" style={{ fontSize: "1.35rem" }}>
                Terms & Conditions
              </h3>
              <p className="text-white-50 mb-0 small">Timespan Management Private Limited</p>
            </div>
          </div>
        </div>

        {/* Content Body */}
        <div className="hm-card-body p-4 p-md-5">
          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">1. INTRODUCTION</h5>
            <p className="text-secondary lh-base">
              Welcome to Timespan Management Private Limited! These Terms and Conditions
              ("Terms") govern your use of our website located at timespan.in and our services.
              Please read these Terms carefully. By accessing our site or using our services, you agree
              to be bound by these Terms and all terms incorporated by reference. If you do not agree to
              all of these terms, do not use our site or services.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">2. SERVICES</h5>
            <p className="text-secondary lh-base">
              We provide various IT products and services through our website. In order to use these
              services, you may be required to provide personal details or other information.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">3. USER OBLIGATIONS</h5>
            <p className="text-secondary lh-base">
              By using this website and our services, you warrant that all data provided by you is
              accurate and up-to-date. Use of personal information submitted to or via the Site is
              governed by our Privacy Policy.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">4. INTELLECTUAL PROPERTY</h5>
            <p className="text-secondary lh-base">
              The Company owns all intellectual property rights in the website and in the material
              published on it. These works are protected by copyright laws worldwide. All such rights
              are reserved.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">5. LIMITATION OF LIABILITY</h5>
            <p className="text-secondary lh-base">
              Our liability for direct losses arising out of our negligence, breach of contract or any
              other cause of action arising out of or in connection with these Terms shall be limited to
              the total price of your Order. In no event shall we be liable for any loss of profits,
              goodwill, loss of business, loss of data or any other indirect or consequential loss or
              damage whatsoever.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">6. CHANGES TO TERMS AND CONDITIONS</h5>
            <p className="text-secondary lh-base">
              We reserve the right, at our discretion, to modify these Terms at any time. Changes will
              be posted on the website with a new effective date. Your continued use of our Services
              following the posting of changes will mean you accept those changes.
            </p>
          </section>

          <section className="mb-4">
            <h5 className="fw-bold text-primary mb-2">7. GOVERNING LAWS AND JURISDICTION</h5>
            <p className="text-secondary lh-base">
              These Terms are governed by the laws of India. Any disputes arising in connection with
              these terms shall be subject to the exclusive jurisdiction of the Courts of India.
            </p>
          </section>

          <section className="mb-2">
            <h5 className="fw-bold text-primary mb-2">8. CONTACT US</h5>
            <p className="text-secondary lh-base mb-0">
              If you have any questions about these Terms, please contact us at:{" "}
              <a href="mailto:info@timespan.in" className="text-primary fw-semibold">
                info@timespan.in
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default Termsandcondition;

